/**
 * Braze Banner placement IDs, as configured in the Braze dashboard (Templates
 * & Media > Banners > Placements). Each entry is a list because the Banners
 * API returns at most one banner per placement ID - a multi-slide carousel
 * needs one placement ID per slide.
 */
export const BRAZE_PLACEMENT_ID = {
  ACCOUNT_SIDE: ['account_side'],
  ACCOUNT_LOYALTY_TOP: ['account_loyalty_top'],
  ACCOUNT_ORDERS_TOP: ['account_orders_top'],
  ACCOUNT_SHIPMENTS_TOP: ['account_shipments_top'],
  ACCOUNT_RETURNS_TOP: ['account_returns_top'],
  CART_SIDE: ['view_cart'],
  /**
   * Slides for the Products page carousel. This list is expected to grow or
   * shrink over time as marketing adds/removes slides in the Braze dashboard
   * - add or remove placement IDs here to match.
   */
  ALL_PRODUCTS_CAROUSEL: [
    'all_products_carousel_1',
    'all_products_carousel_2',
    'all_products_carousel_3',
    'all_products_carousel_4',
    'all_products_carousel_5',
    'all_products_carousel_6',
  ],
} as const;

/**
 * `data-promo-placement` on the Products page carousel wrapper, which GTM reads to identify
 * the placement. Each slide has its own placement ID above, so this is their shared prefix.
 */
export const ALL_PRODUCTS_CAROUSEL_PROMO_PLACEMENT = 'all_products_carousel';

/**
 * Custom event names logged to Braze. Must match exactly what CRM configures
 * as campaign triggers in Braze - these are not typos to "fix" locally.
 */
export const BRAZE_CUSTOM_EVENT_NAME = {
  BANNER_INAPP_CLICKED: 'banner_inapp_clicked',
  /** Spelled `site_visitted` (double t) per the Leafio Braze Banners brief. */
  SITE_VISITED: 'site_visitted',
} as const;
